.rowHeader {
  margin-bottom: 16px;
}

.header {
  height: 24px;
  min-width: 124px;
  max-width: 124px;
}

.productCount {
  margin-top: 8px;
  min-width: 74px;
  max-width: 74px;
}

.viewAll {
  height: 24px;
  min-width: 56px;
  max-width: 56px;
}

@media all and (--reefer-media-tablet-min) {
  .rowHeader {
    margin-top: 40px;
  }

  .header {
    max-width: 240px;
  }

  .viewAll {
    max-width: 129px;
  }
}
